import styled from 'styled-components';

const Wrapper = styled.section`
  margin-top: 2rem;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;

  .btn-container {
    display: flex;
    align-items: center;
    gap: 0.25rem;
    background: #f1f5f9;
    border-radius: 10px;
    padding: 0.25rem;
  }

  .pageBtn {
    background: transparent;
    border: none;
    width: 36px;
    height: 36px;
    border-radius: 7px;
    font-size: 0.875rem;
    font-weight: 600;
    color: #475569;
    cursor: pointer;
    transition: background 0.15s, color 0.15s;
    &:hover { background: #fff; color: #6366f1; }
  }

  .active {
    background: linear-gradient(135deg, #6366f1, #8b5cf6);
    color: #fff;
    box-shadow: 0 2px 8px rgba(99, 102, 241, 0.3);
    &:hover { background: linear-gradient(135deg, #6366f1, #8b5cf6); color: #fff; }
  }

  .prev-btn,
  .next-btn {
    height: 38px;
    padding: 0 1rem;
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 9px;
    font-size: 0.82rem;
    font-weight: 600;
    color: #475569;
    text-transform: capitalize;
    display: flex;
    align-items: center;
    gap: 0.4rem;
    cursor: pointer;
    transition: background 0.15s, color 0.15s, border-color 0.15s;
    &:hover {
      background: #eef2ff;
      color: #6366f1;
      border-color: #c7d2fe;
    }
  }
`;

export default Wrapper;
